import { NgModule } from '@angular/core';
import { HistoricalCustomerMrpCertificatesComponent } from './historical-customer-mrp-certificates.component';
import { HistoricalCustomerMrpCertificatesModal } from './historical-customer-mrp-certificates-modal.component';
import { CustomerMrpCertificatesComponent } from './customer-mrp-certificates.component';
import { CustomerMrpCertificateStatusComponent } from './customer-mrp-certificate-status.component';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';
import { MedicalReviewService } from '@max/medical-review/services/medical-review.service';
import { MVMSpinnerBtnModule } from '@max/shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { FormsModule } from '@angular/forms';
import { ValidationResultsModule } from '@max/shared/components/validation-results/validation-results.module';
import { SharedModule } from '@max/shared/shared.module';
@NgModule({
    declarations: [
        HistoricalCustomerMrpCertificatesComponent,
        HistoricalCustomerMrpCertificatesModal,
        CustomerMrpCertificatesComponent,
        CustomerMrpCertificateStatusComponent
    ],
    imports: [
        CommonModule,
        TableModule,
        SharedPipesModule,
        MVMSpinnerBtnModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        ValidationResultsModule,
        SharedModule
    ],
    providers : [
        MedicalReviewService
    ],
    exports: [
        HistoricalCustomerMrpCertificatesComponent,
        HistoricalCustomerMrpCertificatesModal,
        CustomerMrpCertificatesComponent,
        CustomerMrpCertificateStatusComponent
    ]
})
export class CustomerMrpCertificatesModule {}
